export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      {/* Disclaimer Section */}
      <section className="bg-[#0d1117] py-12 sm:py-16 px-4 sm:px-8 border-t-2 border-[#8B6914]">
        <div className="max-w-[1400px] mx-auto">
          <div className="flex items-start gap-4 mb-6">
            <div className="w-12 h-12 bg-[#8B6914] rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-alert-line text-white text-2xl"></i>
            </div>
            <div>
              <h3 className="text-2xl sm:text-3xl font-bold text-[#F7F7F7] mb-2">Important Legal Disclaimer</h3>
              <p className="text-sm text-[#718096]">Please read carefully before purchasing</p>
            </div>
          </div>

          <div className="bg-[#1f2937] rounded-2xl p-6 sm:p-8 space-y-4 border-l-4 border-[#8B6914]">
            <p className="text-sm sm:text-base text-[#A0AEC0] leading-relaxed">
              <strong className="text-[#F7F7F7]">Legal Compliance:</strong> All weapons sold by Dark Warrior Weapons are intended for lawful purposes only, including collection, display, martial arts training, historical reenactment, and legal self-defense where permitted by law. It is the buyer's responsibility to know and comply with all federal, state, and local laws regarding the purchase, possession, and use of melee weapons in their jurisdiction.
            </p>

            <p className="text-sm sm:text-base text-[#A0AEC0] leading-relaxed">
              <strong className="text-[#F7F7F7]">Age Restriction:</strong> Purchasers must be 18 years of age or older. By placing an order, you confirm that you are of legal age and are legally permitted to own the items you are purchasing.
            </p>

            <p className="text-sm sm:text-base text-[#A0AEC0] leading-relaxed">
              <strong className="text-[#F7F7F7]">Responsible Ownership:</strong> These weapons are functional tools that require proper handling, storage, and use. Buyers assume all responsibility for safe handling and storage. Dark Warrior Weapons is not liable for misuse, injury, or damage resulting from improper use of our products.
            </p>

            <p className="text-sm sm:text-base text-[#A0AEC0] leading-relaxed">
              <strong className="text-[#F7F7F7]">Not Toys:</strong> These are real weapons designed for serious purposes. They are not toys and should never be treated as such. Keep away from children and untrained individuals.
            </p>

            <p className="text-sm sm:text-base text-[#A0AEC0] leading-relaxed">
              <strong className="text-[#F7F7F7]">Training Recommended:</strong> We strongly recommend proper training before using any weapon for self-defense or martial arts purposes. Seek qualified instruction to ensure safe and effective use.
            </p>

            <p className="text-sm sm:text-base text-[#A0AEC0] leading-relaxed">
              <strong className="text-[#F7F7F7]">Shipping Restrictions:</strong> We reserve the right to refuse shipment to any location where possession of these items may be restricted or prohibited. Some jurisdictions may have specific regulations regarding melee weapons.
            </p>

            <div className="pt-4 border-t border-[#4A5568] mt-6">
              <p className="text-xs sm:text-sm text-[#718096] italic">
                By purchasing from Dark Warrior Weapons, you acknowledge that you have read, understood, and agree to comply with this disclaimer and all applicable laws. You accept full responsibility for the legal and safe use of all products purchased.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0d1117] py-12 sm:py-16 lg:py-20 px-4 sm:px-8">
        {/* Upper Grid */}
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-12 sm:py-16 lg:py-20">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12">
            {/* Column 1 - Brand */}
            <div className="space-y-4 sm:space-y-6">
              <div className="flex items-center gap-3 mb-4">
                <img 
                  src="https://public.readdy.ai/ai/img_res/d0bddc9b-861e-48e2-8161-fe8ee0c179e9.png" 
                  alt="Dark Warrior Weapons" 
                  className="h-8 w-8 sm:h-10 sm:w-10 object-contain"
                />
                <span className="text-[#8B6914] font-bold text-lg sm:text-xl tracking-wider">DWW</span>
              </div>
              <p className="text-xs sm:text-sm text-gray-400 leading-relaxed">
                Handcrafted melee weapons for collectors, warriors, and those who value preparedness. Built with precision, designed to last.
              </p>
            </div>

            {/* Column 2 - Newsletter */}
            <div className="space-y-4">
              <h3 className="text-[10px] sm:text-xs uppercase tracking-wide text-[#718096] font-semibold">STAY SHARP</h3>
              <form id="newsletter-form" data-readdy-form onSubmit={(e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const emailInput = form.querySelector('input[name="email"]') as HTMLInputElement;
                
                if (emailInput && emailInput.value) {
                  const formData = new URLSearchParams();
                  formData.append('email', emailInput.value);
                  
                  fetch('https://readdy.ai/api/form/d5roaqutc768qf4bqm6g', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: formData.toString()
                  }).then(() => {
                    emailInput.value = '';
                    alert('Subscribed successfully!');
                  }).catch(() => {
                    alert('Subscription failed. Please try again.');
                  });
                }
              }}>
                <div className="relative">
                  <input
                    type="email"
                    name="email"
                    placeholder="Your email"
                    required
                    className="w-full bg-transparent border-b-2 border-[#8B6914] py-2 pr-12 text-sm sm:text-base text-white placeholder-gray-500 focus:outline-none"
                  />
                  <button
                    type="submit"
                    className="absolute right-0 top-1/2 transform -translate-y-1/2 w-8 h-8 bg-[#8B6914] rounded-full flex items-center justify-center hover:bg-[#6B4423] transition-colors cursor-pointer"
                  >
                    <i className="ri-arrow-right-line text-white text-sm"></i>
                  </button>
                </div>
              </form>
              <p className="text-[10px] sm:text-xs text-gray-500">
                By subscribing, you agree to our <a href="#" className="underline hover:text-[#8B6914] cursor-pointer">Privacy Policy</a>
              </p>
            </div>

            {/* Column 3 - Quick Links */}
            <div className="space-y-4">
              <h3 className="text-[10px] sm:text-xs uppercase tracking-wide text-[#718096] font-semibold">NAVIGATE</h3>
              <nav className="flex flex-col gap-2 sm:gap-3">
                <button onClick={() => scrollToSection('products')} className="text-sm sm:text-base text-[#F7F7F7] hover:text-[#8B6914] transition-colors text-left cursor-pointer">
                  Arsenal
                </button>
                <button onClick={() => scrollToSection('about')} className="text-sm sm:text-base text-[#F7F7F7] hover:text-[#8B6914] transition-colors text-left cursor-pointer">
                  Craft Story
                </button>
                <button onClick={() => scrollToSection('contact')} className="text-sm sm:text-base text-[#F7F7F7] hover:text-[#8B6914] transition-colors text-left cursor-pointer">
                  Contact
                </button>
                <a href="#" className="text-sm sm:text-base text-[#F7F7F7] hover:text-[#8B6914] transition-colors cursor-pointer">
                  Legal & Safety
                </a>
              </nav>
            </div>

            {/* Column 4 - Social/Legal */}
            <div className="space-y-4">
              <h3 className="text-[10px] sm:text-xs uppercase tracking-wide text-[#718096] font-semibold">CONNECT</h3>
              <nav className="flex flex-col gap-2 sm:gap-3">
                <a href="#" className="text-sm sm:text-base text-[#F7F7F7] hover:text-[#8B6914] transition-colors cursor-pointer">
                  Instagram
                </a>
                <a href="#" className="text-sm sm:text-base text-[#F7F7F7] hover:text-[#8B6914] transition-colors cursor-pointer">
                  YouTube
                </a>
                <a href="#" className="text-sm sm:text-base text-[#F7F7F7] hover:text-[#8B6914] transition-colors cursor-pointer">
                  Facebook
                </a>
                <a href="#" className="text-sm sm:text-base text-[#F7F7F7] hover:text-[#8B6914] transition-colors text-sm mt-4 cursor-pointer">
                  Terms of Service
                </a>
              </nav>
            </div>
          </div>
        </div>

        {/* Lower Section - Brand Typography */}
        <div className="relative h-[150px] sm:h-[200px] lg:h-[300px] flex items-center justify-center overflow-hidden px-4">
          <div
            className="text-[40px] sm:text-[80px] lg:text-[120px] font-black text-transparent opacity-15 text-center"
            style={{
              WebkitTextStroke: '2px #F5F5DC',
              letterSpacing: '-2px'
            }}
          >
            DARK WARRIOR
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800">
          <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-4 sm:py-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs sm:text-sm text-gray-500">
            <p className="text-center sm:text-left">&copy; 2024 Dark Warrior Weapons. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </>
  );
}
